import axiosInstance from "app/axiosInstance";
import {
  RideHistoryRequestDto,
  RideHistoryResponseDto
} from "../entities/dtos/ride-history.dto";

export const getRideHistory = async ({
  accountId,
  objectId,
  rideId
}: RideHistoryRequestDto): Promise<RideHistoryResponseDto> => {
  try {
    const response = await axiosInstance.get(
      `/accounts/${accountId}/objects/${objectId}/rides/${rideId}/history`
    );

    return response.data;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
